

  import 'swiper/swiper-bundle.min.css';
  import {Swiper as SwiperClass} from 'swiper';
  import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
  import { Component, Prop, Vue, Ref } from 'vue-property-decorator';
  import { Swiper, SwiperRef } from 'vue-awesome-swiper';
  import { BIconChevronRight, BIconChevronLeft } from 'bootstrap-vue';

  @Component({
    components: { Swiper, BIconChevronRight, BIconChevronLeft },
    directives: {
      swiper: getAwesomeSwiper(SwiperClass).directive
    },
  })
  export default class Carousel extends Vue {
    @Prop({default: undefined}) readonly slideTo?: number;

    @Ref('slider') readonly slider!: SwiperRef;

    mounted() {
      if (this.slideTo) this.slider.$swiper.slideTo(this.slideTo);
    }

    swiperOption = {
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        720: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: '.next-elem',
        prevEl: '.prev-elem',
      },
    };
  }
